import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Home,
  FileText,
  TrendingUp,
  AlertTriangle,
  Users,
  Sparkles,
} from 'lucide-react';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'dashboard',
      icon: Home,
      label: 'Inicio',
      path: '/dashboard',
    },
    {
      id: 'documents',
      icon: FileText,
      label: 'Docs',
      path: '/documents',
    },
    {
      id: 'social',
      icon: TrendingUp,
      label: 'Social',
      path: '/social',
    },
    {
      id: 'alerts',
      icon: AlertTriangle,
      label: 'Alertas',
      path: '/alerts',
    },
    {
      id: 'ai-tools',
      icon: Sparkles,
      label: 'IA',
      path: '/ai-tools',
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="mobile-bottom-nav md:hidden">
      <div className="mobile-bottom-nav-container">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`mobile-nav-item ${active ? 'active' : ''}`}
              data-testid={`mobile-nav-${item.id}`}
            >
              <div className="mobile-nav-icon-wrapper">
                {active && (
                  <motion.div
                    layoutId="mobile-nav-indicator"
                    className="mobile-nav-indicator"
                    transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                  />
                )}
                <Icon className={`mobile-nav-icon ${active ? 'text-purple-400' : 'text-gray-400'}`} />
              </div>
              <span className={`mobile-nav-label ${active ? 'text-white' : 'text-gray-500'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
